// the logic here is needed to migrate the date and time of the events to the new format
// we were rushing with releasing Wedding Websites and it got out with
// OLD DATE FORMAT
// { date: '2025-04-22T12:00:00.000Z/2025-04-22T13:00:00.000Z' };
// NEW DATE FORMAT
// { date: '2025-04-22', time: { startTime: '12:00', endTime: '13:00' } };
// additonally in the new format, we don't have the date stored for the main event
import { format, parseISO } from 'date-fns';
import partition from 'lodash/partition';
import { IWeddingEvent } from '@bridebook/models/source/models/Weddings/Events.types';
import { isMainEvent } from '@bridebook/web/lib/events/types';

export const isOldDate = (date: string) => {
  if (!date || typeof date !== 'string') return false;
  return date.includes('T') && date.includes('/') && date.includes(':');
};

export const convertOldDateToDateAndTime = (oldDate: string) => {
  const [startDate, endDate] = oldDate.split('/');
  const startDateISO = parseISO(startDate);
  const endDateISO = parseISO(endDate);
  const dateString = format(startDateISO, 'yyyy-MM-dd');
  const startTime = format(startDateISO, 'HH:mm');
  const endTime = format(endDateISO, 'HH:mm');
  const time = startTime === endTime ? {} : { startTime, endTime };
  return {
    date: dateString,
    time,
  };
};

// Events pulled from firebase should be passed through this function
// to make sure they are in the new format. Some of the events created in early
// days of Wedding Websites were created with the old format and this function makes sure they are converted to the new format before returned
export const convertOldEventsToNewEvents = (oldEvents: IWeddingEvent[]) => {
  const [mainEvents, customEvents] = partition(oldEvents, isMainEvent);
  const convertedCustomEvents = customEvents.map((event) => {
    if (isOldDate(event.date)) {
      const { date, time } = convertOldDateToDateAndTime(event.date);
      return {
        ...event,
        date,
        time,
      };
    }
    return event;
  });

  const correctedMainEvent = mainEvents.map((event) => {
    const typedEvent = event as unknown as { date: string };
    if (isOldDate(typedEvent.date)) {
      const { time } = convertOldDateToDateAndTime(typedEvent.date);
      return {
        ...event,
        time,
      };
    }
    return event;
  });

  return [...correctedMainEvent, ...convertedCustomEvents];
};
